import { useEffect, useState } from "react";

const REFRESH_INTERVAL_MS = 120_000;

export const useRefreshTick = (intervalMs?: number) => {
  const [refreshTick, setRefreshTick] = useState(0);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRefreshTick((t) => t + 1);
    }, intervalMs || REFRESH_INTERVAL_MS);

    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        setRefreshTick((t) => t + 1);
      }
    };
    const handleFocus = () => {
      setRefreshTick((t) => t + 1);
    };

    document.addEventListener("visibilitychange", handleVisibility);
    window.addEventListener("focus", handleFocus);

    return () => {
      window.clearInterval(id);
      document.removeEventListener("visibilitychange", handleVisibility);
      window.removeEventListener("focus", handleFocus);
    };
  }, []);

  return refreshTick;
};
